import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
	selector: '[prefixIcon]',
	template: '@if (prefixIconClass != \'\') {' +
		' <div class="prefix-icon-container">' +
		'		<div class="prefix-icon" [ngClass]="prefixIconClass"></div>' +
		'		<div class="prefix-icon-content"><ng-container *ngTemplateOutlet="contentTpl"></ng-container></div>' +
		'	</div>' +
		'}' +
		'@if (prefixIconClass == \'\') {' +
		'	<ng-container *ngTemplateOutlet="contentTpl"></ng-container>' +
		'}' +
		'<ng-template #contentTpl><ng-content></ng-content></ng-template>',
	styleUrls: ['./prefix-icon.component.scss'],
	imports: [NgClass, NgTemplateOutlet]
})
export class PrefixIconComponent {

	@Input('prefixIcon') prefixIconClass = '';

}
